<template>
  <b-modal id="matrix-create-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow" no-close-on-backdrop>
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ $t('admin.create_matrix') }}</span>
      </div>
    </template>

    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template v-if="!isLoading">
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('admin.position') }}</div>
        <v-select :options="positionOptions" :clearable="false" v-model="position" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('admin.be') }}</div>
        <v-select :options="beOptions" :clearable="false" v-model="be" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('admin.direction') }}</div>
        <v-select :options="directionOptions" :clearable="false" v-model="direction" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('admin.priority') }}</div>
        <v-select :options="priorityOptions" :clearable="false" v-model="priority" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('admin.documents') }}</div>
        <v-select :options="documentsOptions" :clearable="false" v-model="documents" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('admin.periodicity') }}</div>
        <v-select :options="periodicityOptions" :clearable="false" v-model="periodicity" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('admin.activity_link') }}</label>
        <input type="text" v-model="activityLinkName" class="adp-input adp-input__text" @input="searchCatalog">
        <div class="adp-modal-row-search" v-if="searchedCatalogItems.length > 0">
          <div v-for="activity in searchedCatalogItems" class="adp-modal-row-search__item" style="height: auto">
            <span class="pl-3" @click="selectCatalogActivity(activity)">{{ activity.name }}</span>
          </div>
        </div>
      </div>

    </template>
    <template #modal-footer>
      <button id="save" class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto" @click="create()"
              :disabled="!position || !be || !direction || !priority || !documents || !periodicity || !activityLinkName">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import api from "../../api";

export default {
  name: "MatrixCreateModal",
  components: {
  },
  data: function () {
    return {
      isLoading: false,
      catalogItems: [],
      searchedCatalogItems: [],

      position: null,
      be: null,
      direction: null,
      priority: null,
      documents: null,
      periodicity: null,
      activityLinkName: null,
      activityLinkId: null,

      positionOptions: [],
      beOptions: [],
      directionOptions: [],
      priorityOptions: [],
      documentsOptions: [],
      periodicityOptions: [],
    }
  },
  computed: {
  },
  watch: {
    activityLinkName(newVal) {
      if (newVal.length > 12) this.searchedCatalogItems = [];
    },
  },
  methods: {
    async onShow() {
      this.isLoading = true;

      this.position = null;
      this.be = null;
      this.direction = null;
      this.priority = null;
      this.documents = null;
      this.periodicity = null;
      this.activityLinkName = null;

      this.directionOptions = window.IDP.matrix_directions.map(item => ({code: item, label: this.$t(`admin.${item}`)}));
      this.periodicityOptions = window.IDP.matrix_periodicity.map(item => ({code: item, label: this.$t(`admin.${item}`)}));
      this.beOptions = Object.keys(window.IDP.companies).map(item => ({code: String(item), label: String(item)}));
      this.positionOptions = window.IDP.positions.map(item => ({code: String(item), label: String(item)}));
      this.priorityOptions = window.IDP.matrix_prioriries.map(item => ({code: String(item), label: this.$t(`admin.${item}`)}));
      this.documentsOptions = window.IDP.matrix_documents.map(item => ({code: String(item), label: this.$t(`admin.${item}`)}));

      this.isLoading = false;
    },
    async getCatalog() {
      const resp = await api.getMatrixCatalogList();
      this.catalogItems = resp.data;
    },
    async searchCatalog() {
      if (this.activityLinkName.length > 2) {
        this.searchedCatalogItems =
          this.catalogItems.filter(item => item.name.toLowerCase().includes(this.activityLinkName.toLowerCase()));
      } else {
        this.searchedCatalogItems = [];
      }
    },
    selectCatalogActivity(activity) {
      this.activityLinkName = activity.name;
      this.activityLinkId = activity.id;
    },
    async create() {
      const data = {
        'catalog_activity_id': this.activityLinkId,
        'title': this.activityLinkName,
        'direction': this.direction,
        'position': this.position,
        'company': this.be,
        'periodicity': this.periodicity,
        'priority': this.priority,
        'documents': this.documents,
        'status': 'active',
      }

      try {
        let resp = await api.createMatrixActivity(data);
        if (resp.status === 201) {
          this.$bvModal.hide('matrix-create-modal');
          this.$emit('matrix-created');
        }
      } catch (e) {
        console.error(e.response.data);
        this.$toasts.error(e.response.data.errors, {
          duration: 700000,
        });
      }
    },
  },
  mounted() {
    this.getCatalog();
  }
}
</script>
